import { c as O } from "./clsx-OuTLNxxd.js";
const m = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, y = O, j = (e, a) => (n) => {
  var u;
  if (a?.variants == null) return y(e, n?.class, n?.className);
  const { variants: r, defaultVariants: s } = a, V = Object.keys(r).map((t) => {
    const l = n?.[t], d = s?.[t];
    if (l === null) return null;
    const i = m(l) || m(d);
    return r[t][i];
  }), v = n && Object.entries(n).reduce((t, l) => {
    let [d, i] = l;
    return i === void 0 || (t[d] = i), t;
  }, {}), N = a == null || (u = a.compoundVariants) === null || u === void 0 ? void 0 : u.reduce((t, l) => {
    let { class: d, className: i, ...f } = l;
    return Object.entries(f).every((C) => {
      let [c, o] = C;
      return Array.isArray(o) ? o.includes({
        ...s,
        ...v
      }[c]) : {
        ...s,
        ...v
      }[c] === o;
    }) ? [
      ...t,
      d,
      i
    ] : t;
  }, []);
  return y(e, V, N, n?.class, n?.className);
};
export {
  y as a,
  j as c
};
//# sourceMappingURL=index-DI5SPFK9.js.map
